module.exports = __webpack_public_path__ + "img/visipoint logo@2x.cb804f7b.jpg";